/** IANA timezone passed to time-bucketed EMR endpoints. */
export var EMR_TIMEZONE = "Asia/Calcutta";

/** Number of rows previewed in a panel section before the view-all action. */
export var PANEL_PREVIEW_COUNT = 5;

/** Base route to the DICOM viewer; the patient uid is appended. */
export var VIEWER_ROUTE = "/viewer-v2/";